import {
  ActionMenuItem,
  ActionMenuItemContent,
  ActionMenuLink,
  stenaCog,
  stenaSignOut,
  stenaUserCircle,
} from "@stenajs-webui/elements";
import { NavBarUserButton } from "@stenajs-webui/panels";
import cx from "classnames";
import type { FC } from "react";
import { useSelector } from "react-redux";

import { Link } from "../../../common-ui/Link";
import { useUserDisplayName } from "../../../services/authentication/hooks/useUserName";
import { useUserLoginEmail } from "../../../services/settings/hooks/useAccount";
import { getIsNewFeatureTourRunning } from "../../../services/tour/tourReducer";
import { getPortalRoot } from "../../../use-cases/manage/grid/utils/getPortalRoot";
import { routeCreators } from "../../routes/AppRoutes";
import { trackEvent } from "../../tracking/trackerService";

import styles from "./AccountMenuButton.module.css";

export interface AccountMenuButtonProps {
  onLogOut: () => void;
}

const portalRoot = getPortalRoot();

export const AccountMenuButton: FC<AccountMenuButtonProps> = ({ onLogOut }) => {
  const userDisplayName = useUserDisplayName();
  const userLoginEmail = useUserLoginEmail();
  const isTourRunning = useSelector(getIsNewFeatureTourRunning);

  return (
    <NavBarUserButton
      disableTrapFocus={isTourRunning}
      icon={stenaUserCircle}
      className={cx("t_user_button", styles.accountMenuButton)}
      appendTo={portalRoot}
      username={userDisplayName}
      renderItems={() => (
        <>
          <ActionMenuItemContent label={userLoginEmail ?? ""} />
          <Link
            render={(props) => (
              <ActionMenuLink
                {...props}
                leftIcon={stenaCog}
                label={"Settings"}
                className={"tour_settings_link"}
              />
            )}
            onClick={() => {
              trackEvent({
                category: "AccountMenu",
                action: "Navigate to Settings",
              });
            }}
            to={routeCreators.settings()}
          />
          <ActionMenuItem
            onClick={onLogOut}
            className={"t_logout_link"}
            leftIcon={stenaSignOut}
            label={"Log out"}
          />
        </>
      )}
    />
  );
};
